module.exports = __webpack_public_path__ + "img/yes-bl.a89bcb0e.png";